import React from "react";
import "./ClientLogos.css";

const LOGOS = [
  { name: "Skill Council for Green Jobs", gray: "/logos/skill-council-for-green-jobs-gray.jpg", color: "/logos/skill-council-for-green-jobs-color.jpg" },
  { name: "Landscope Mauritius", gray: "/logos/landscope-mauritius-gray.jpg", color: "/logos/landscope-mauritius-color.jpg" },
  { name: "Mahindra", gray: "/logos/mahindra-gray.jpg", color: "/logos/mahindra-color.jpg" },
  { name: "Sterlite Power", gray: "/logos/sterlite-power-gray.jpg", color: "/logos/sterlite-power-color.jpg" },
  { name: "Serentica", gray: "/logos/serentica-gray.jpg", color: "/logos/serentica-color.jpg" },
  { name: "TATA", gray: "/logos/tata-gray.jpg", color: "/logos/tata-color.jpg" },
  { name: "JEL", gray: "/logos/jel-gray.jpg", color: "/logos/jel-color.jpg" },
  { name: "Amazon", gray: "/logos/amazon-gray.jpg", color: "/logos/amazon-color.jpg" },
  { name: "AML Mauritius", gray: "/logos/aml-mauritius-gray.jpg", color: "/logos/aml-mauritius-color.jpg" },
  { name: "BCPG", gray: "/logos/bcpg-gray.jpg", color: "/logos/bcpg-color.jpg" },
  { name: "Capital Fortunes", gray: "/logos/capital-fortunes-gray.jpg", color: "/logos/capital-fortunes-color.jpg" },
  { name: "CBRE", gray: "/logos/cbre-gray.jpg", color: "/logos/cbre-color.jpg" },
  { name: "EM-ONE Energy Solutions", gray: "/logos/em-one-energy-solutions-gray.jpg", color: "/logos/em-one-energy-solutions-color.jpg" },
  { name: "Jaquar", gray: "/logos/jaquar-gray.jpg", color: "/logos/jaquar-color.jpg" },
];

export default function ClientLogos() {
  const row1 = [...LOGOS.slice(0, 7), ...LOGOS.slice(0, 7)];
  const row2 = [...LOGOS.slice(7),    ...LOGOS.slice(7)];

  const LogoItem = ({ logo }) => (
    <div className="cl-item" title={logo.name}>
      <div className="cl-wrap">
        <img className="cl-base"  src={logo.gray}  alt={logo.name} />
        <img className="cl-hover" src={logo.color} alt={logo.name} />
      </div>
    </div>
  );

  return (
    <section className="cl-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-10">
        <div className="overline">Trusted by</div>
        <h2 className="font-serif text-4xl md:text-5xl mt-3" style={{ color: "var(--primary)" }}>
          Industry leaders.
        </h2>
      </div>
      <div className="cl-marquee-wrapper">
        <div className="cl-row cl-row-left">
          {row1.map((logo, i) => <LogoItem key={i} logo={logo} />)}
        </div>
        <div className="cl-row cl-row-right">
          {row2.map((logo, i) => <LogoItem key={i} logo={logo} />)}
        </div>
      </div>
    </section>
  );
}
